import {animate, query, style, transition, trigger} from '@angular/animations';

/**
 * Fade route must be placed in a positioned element that is parent of the router outlet.
 *
 * The child components must be absolute positioned to replace the content smoothly
 */
export const FadeRoute = trigger('routeAnimations', [
  transition('*=>*', [

    query(
      ':enter', [style({ opacity: 0 })],
      { optional: true }
    ),
    query(
      ':leave', [style({ opacity: 1 }), animate('200ms', style({ opacity: 0 }))],
      { optional: true }
    ),
    query(
      ':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))],
      { optional: true }
    )
  ]),
]);
